export const DIGITAL_ARCHIVE_PAGES = {
  ARCHIVE: {
    name: 'Gerenciamento de acervo digital',
    description: 'Gestao de todos os acervos digitais',
  },
  DIRECTORY: {
    name: 'Gerenciamento das pastas e arquivos de um acervo',
    description: 'Gestao das pastas e arquivos de um acervo',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
}
